import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M22 2H2.01L2 22l4-4h16V2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z"
}), 'ChatSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/ChatSharp.js
// module id = 2751
// module chunks = 2